import { render, staticRenderFns } from "./LogisticsPopup.vue?vue&type=template&id=30b9428a&scoped=true&"
import script from "./LogisticsPopup.vue?vue&type=script&lang=js&"
export * from "./LogisticsPopup.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsPopup.vue?vue&type=style&index=0&id=30b9428a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9428a",
  null
  
)

export default component.exports